import React from "react";

const DeleteIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_321_1317)">
        <rect
          x="2"
          y="1"
          width="32"
          height="32"
          rx="4"
          fill="none"
          shapeRendering="crispEdges"
        />
        <path
          d="M13 26C12.45 26 11.9792 25.8042 11.5875 25.4125C11.1958 25.0208 11 24.55 11 24V11H10V9H15V8H21V9H26V11H25V24C25 24.55 24.8042 25.0208 24.4125 25.4125C24.0208 25.8042 23.55 26 23 26H13V26M23 11H13V24V24V24H23V24V24V11V11M15 22H17V13H15V22V22M19 22H21V13H19V22V22M13 11V11V24V24V24V24V24V24V11V11"
          fill="#0F1560"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_321_1317"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_321_1317"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_321_1317"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default DeleteIcon;
